var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.checkPackage())?_c('team'):_vm._e(),(_vm.checkPackage())?_c('news'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }